import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h3
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
            color: "black",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h3>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Wetlands include lentic and lotic water bodies and constitute the
              most diverse and productive ecosystem, providing numerous
              ecological, economic, and social benefits to society. Wetlands
              provide vital ecosystem services and processes, such as the
              provision of food (fish, fodder, etc.), groundwater recharge,
              water purification, remediation, nutrient assimilation, carbon
              sequestration, moderating micro-climate, habitat for flora and
              fauna, flood reduction, erosion control, opportunities for
              education, aesthetics, and recreation (de Groot et al. 2020;
              Ramachandra et al. 2019; Barbier 2013; Lambert 2003; Costanza et
              al. 1997). Wetlands help to conserve biodiversity by providing
              habitat for fish, planktons, aquatic plants, insects, and
              crustaceans, as well as feeding and resting areas for water birds
              (Ramachandra et al. 2016). Food chains/food webs describe the
              structure of communities inhabiting a particular ecosystem, and
              the associated energy as well as nutrient flows, and the
              interactions between species (Ramachandra et al. 2005). Wetlands
              aid in removing nutrients like nitrate, phosphate, etc., from
              water (Ramachandra et al. 2021; Ramachandra et al. 2020a).
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/esk1.jpg" alt="" />
            </p>
            <p style={{textAlign:"center"}}>
              <strong>Figure 1: </strong>Wetland ecosystem function and service
              valuation
            </p>
            <p>
              Ecosystem functions of wetlands illustrated in figure 1, include
              food production, habitat provision, information provision, and
              regulation of ecosystem processes. Microalgae are primary
              producers that sequester carbon and synthesize food and energy for
              higher trophic levels (Kulkarni and Ramachandra 2006; Peel et al.
              2019). Enhanced oxygen levels on early Earth, triggering aerobic
              respiration and the evolution of complex multicellular life forms
              are due to photosynthesis by microalgae (cyanobacteria) and the
              release of oxygen (S&aacute;nchez-Baracaldo and Cardona 2020).
              Wetlands provide food and shelter for diverse aquatic organisms
              (zooplankton, fish, and birds), fodder (livestock and other
              grazers), medicine, water purification/treatment (remediation),
              and carbon sequestration (Ramachandra et al. 2020b; Ramachandra et
              al. 2014). Fish store nutrients in their tissues, translocate
              nutrients, and excrete dietary nutrients in dissolved forms that
              are readily available to primary producers (Vanni 2002). Fish
              feeding alters the community structure of phytoplankton,
              zooplankton, and insects (Griffiths 2006).
            </p>
            <p>
              Wetlands provide numerous ecosystem services, sustaining the
              livelihoods of dependent populations with the provisioning,
              regulating, and cultural services, and hence there is a need to
              quantify the socio-cultural, ecological, and economic value of
              wetlands (TEEB 2010) for appropriate management strategies by
              policymakers, and other stakeholders (figure 1) with incentives,
              and financial support for conservation. Prudent management with
              the sustainable use of wetlands would aid in maintaining
              biodiversity, mitigating pollution, and changes in the climate.
            </p>
            <p>
              <strong>Ecosystem service from wetlands</strong>
            </p>
            <p>
              Ecosystem services are the benefits derived from nature for human
              wellbeing (figure 2). Ecosystem services are categorized as
              provisioning services, regulating services, and cultural services
              (SEEA 2021; Millennium Ecosystem Assessment (MEA); Common
              International Classification of Ecosystem Services (CICES)).
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/esk2.jpg" alt="" />
            </p>
            <p style={{textAlign:"center"}}>
              <strong>Figure 2: </strong>Ecosystem services from wetlands
            </p>
            <p>
              Provisioning services are the tangible benefits that include
              products obtained from ecosystems such as water, food, fiber,
              fuel, genetic resources, biochemical, medicines, and
              pharmaceuticals. Regulating services include the benefits obtained
              from various ecosystem processes, such as water regulation,
              climate regulation, water purification, erosion regulation, and
              flood control. Cultural services include the nonmaterial benefits
              from ecosystems through spiritual, recreation, aesthetics
              experiences, and ecotourism (Magalh&atilde;es Filho et al. 2021).
              These benefits vary depending on the geographical scale, from
              local to global. Table 1 lists wetland ecosystem services based on
              global studies. The economic value of a wetland depends on the
              ecosystem process, including catchment characteristics (hydrology,
              vegetation, and soil), geographical conditions, and socio-economic
              aspects (Yiran et al. 2014).
            </p>
            <p>
              <strong>Table 1:</strong> Wetland ecosystem values in $/ha/yr
              based on global studies
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <strong>Services</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>de Groot et al. 2020</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Clarkson et al. 2013</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>de Groot et al. 2012</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Costanza et al. 1997</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Russi et al. 2013</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Quintas-Sorian et al. 2016</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Li &amp; Gao 2016</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Zang et al. 2011</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Zhang et al. 2015</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Food</p>
                  </td>
                  <td style={styles.cell}>
                    <p>6,030</p>
                  </td>
                  <td style={styles.cell}>
                    <p>614</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1111</p>
                  </td>
                  <td style={styles.cell}>
                    <p>256</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2090</p>
                  </td>
                  <td style={styles.cell}>
                    <p>479</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>26</p>
                  </td>
                  <td style={styles.cell}>
                    <p>14</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Water</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1,934</p>
                  </td>
                  <td style={styles.cell}>
                    <p>408</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1217</p>
                  </td>
                  <td style={styles.cell}>
                    <p>3800</p>
                  </td>
                  <td style={styles.cell}>
                    <p>5189</p>
                  </td>
                  <td style={styles.cell}>
                    <p>234</p>
                  </td>
                  <td style={styles.cell}>
                    <p>3800</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>2872</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Raw materials</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1,682</p>
                  </td>
                  <td style={styles.cell}>
                    <p>425</p>
                  </td>
                  <td style={styles.cell}>
                    <p>358</p>
                  </td>
                  <td style={styles.cell}>
                    <p>106</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2430</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>106</p>
                  </td>
                  <td style={styles.cell}>
                    <p>5</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Genetic resources</p>
                  </td>
                  <td style={styles.cell}>
                    <p>60</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>10</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Medicinal resources</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>99</p>
                  </td>
                  <td style={styles.cell}>
                    <p>301</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Ornamental resources</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>114</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Air quality regulation</p>
                  </td>
                  <td style={styles.cell}>
                    <p>34</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>133</p>
                  </td>
                  <td style={styles.cell}>
                    <p>118</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Climate regulation</p>
                  </td>
                  <td style={styles.cell}>
                    <p>150</p>
                  </td>
                  <td style={styles.cell}>
                    <p>488</p>
                  </td>
                  <td style={styles.cell}>
                    <p>65</p>
                  </td>
                  <td style={styles.cell}>
                    <p>330</p>
                  </td>
                  <td style={styles.cell}>
                    <p>351</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>1148</p>
                  </td>
                  <td style={styles.cell}>
                    <p>65</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Moderation of extreme events</p>
                  </td>
                  <td style={styles.cell}>
                    <p>13,320</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2986</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>4430</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Regulation of water flows</p>
                  </td>
                  <td style={styles.cell}>
                    <p>3,638</p>
                  </td>
                  <td style={styles.cell}>
                    <p>5606</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>15</p>
                  </td>
                  <td style={styles.cell}>
                    <p>9369</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>2345</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Waste treatment</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2,043</p>
                  </td>
                  <td style={styles.cell}>
                    <p>3015</p>
                  </td>
                  <td style={styles.cell}>
                    <p>162125</p>
                  </td>
                  <td style={styles.cell}>
                    <p>4177</p>
                  </td>
                  <td style={styles.cell}>
                    <p>4280</p>
                  </td>
                  <td style={styles.cell}>
                    <p>175</p>
                  </td>
                  <td style={styles.cell}>
                    <p>4177</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2376</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2562</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Erosion prevention</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>2607</p>
                  </td>
                  <td style={styles.cell}>
                    <p>3929</p>
                  </td>
                  <td style={styles.cell}>
                    <p>4539</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>41</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Maintenance of soil fertility</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>1713</p>
                  </td>
                  <td style={styles.cell}>
                    <p>45</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>4588</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>112</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Biological control</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>948</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>20</p>
                  </td>
                  <td style={styles.cell}>
                    <p>304</p>
                  </td>
                  <td style={styles.cell}>
                    <p>326</p>
                  </td>
                  <td style={styles.cell}>
                    <p>351</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Maintenance of life cycles of migratory species</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1,886</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1287</p>
                  </td>
                  <td style={styles.cell}>
                    <p>10648</p>
                  </td>
                  <td style={styles.cell}>
                    <p>304</p>
                  </td>
                  <td style={styles.cell}>
                    <p>917</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Maintenance of genetic diversity</p>
                  </td>
                  <td style={styles.cell}>
                    <p>3,427</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1168</p>
                  </td>
                  <td style={styles.cell}>
                    <p>6490</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>2554</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Aesthetic information</p>
                  </td>
                  <td style={styles.cell}>
                    <p>49</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1292</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>3906</p>
                  </td>
                  <td style={styles.cell}>
                    <p>109</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Opportunities for recreation and tourism</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2,660</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2211</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2193</p>
                  </td>
                  <td style={styles.cell}>
                    <p>574</p>
                  </td>
                  <td style={styles.cell}>
                    <p>3700</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>574</p>
                  </td>
                  <td style={styles.cell}>
                    <p>646</p>
                  </td>
                  <td style={styles.cell}>
                    <p>612</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Inspiration for culture, art and design</p>
                  </td>
                  <td style={styles.cell}>
                    <p>114</p>
                  </td>
                  <td style={styles.cell}>
                    <p>700</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>881</p>
                  </td>
                  <td style={styles.cell}>
                    <p>793</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>881</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Spiritual experience</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Information for cognitive development</p>
                  </td>
                  <td style={styles.cell}>
                    <p>120</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Existence and bequest values</p>
                  </td>
                  <td style={styles.cell}>
                    <p>11,498</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>
                    <p>8</p>
                  </td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                  <td style={styles.cell}>&nbsp;</td>
                </tr>
              </tbody>
            </table>
            <p>
              Freshwater lakes provide various services supporting the
              livelihoods of dependent communities, which include the provision
              of fish (food), fodder (livestock), water (drinking and
              irrigation), navigation, recreation, and socio-economic
              development (Najar and Khan 2012), generation of hydropower, etc.
              (Anshumali and Ramanathan 2007). Recreation services of wetlands
              are evident as tourism is a major source of income, and employment
              in Rudrasagar lake (Burman et al. 2007). The wetland ecosystem
              supply values range from 7670 (Andhra Pradesh), 7689.4 (Gujarat)
              to 7896.5 (Karnataka) million US$yr<sup>&minus;1</sup> (Pandey et
              al. 2004). Table 2 lists the computation of ecosystem services,
              wherein provisioning services were accounted based on the market
              value method, while regulating and cultural services were based on
              the benefit transfer method.
            </p>
            <p>
              <strong>Table 2: </strong>Various methods adopted for ecosystem
              service valuation
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <strong>Name of the wetland</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Area</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Total value of ecosystem service </strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>
                        Method used for ecosystem service valuation
                      </strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Reference</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Rachenahalli Lake, Karnataka</p>
                  </td>
                  <td style={styles.cell}>
                    <p>42.09 ha</p>
                  </td>
                  <td style={styles.cell}>
                    <p>10435 Rs/ha/day</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      Market prices method and CVM (contingent valuation
                      method), socio-economic survey and questionnaire
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Ramachandra et al. 2005</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Varthur Lake, Karnataka</p>
                  </td>
                  <td style={styles.cell}>
                    <p>220 ha</p>
                  </td>
                  <td style={styles.cell}>
                    <p>9554000 Rs/220ha/yr</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      Market prices method and CVM, socio-economic survey and
                      questionnaire
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Ramachandra et al. 2011</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Begnas watershed system</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      49 km<sup>2</sup>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>US 3.91 million/yr</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      Market price method, TC method, CVM, and benefit transfer
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Thapa et al. 2020</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Lake and marsh wetlands, China</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      3.241 &times; 10<sup>4</sup> km<sup>2</sup>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      8.1841 &times; 10<sup>10</sup> (USD)
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Value transfer method</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Yiran et al. 2014</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Songore wetland, Zimbabwe</p>
                  </td>
                  <td style={styles.cell}>
                    <p>56.25 ha</p>
                  </td>
                  <td style={styles.cell}>
                    <p>20,843.31$/yr</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Market price method</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Mahlatini et al. 2020</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Rural wetland Letseng-la-Letsie, South Africa</p>
                  </td>
                  <td style={styles.cell}>
                    <p>819 ha</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Provisioning services:$220&middot;ha/yr</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Market price method</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Lannas and Turpie 2009</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Peri-urban wetland Mfuleni, South Africa</p>
                  </td>
                  <td style={styles.cell}>
                    <p>310 ha</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Provisioning services:$1765 ha/yr</p>
                  </td>
                  <td colSpan={2} style={styles.cell}>
                    <p></p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Kalyanthakur para lake, Tripura</p>
                  </td>
                  <td style={styles.cell}>
                    <p>7.84 ha</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Provisioning services: US$ 26263.65/yr</p>
                    <p>Cultural services: US$ 2605.68/yr</p>
                  </td>
                  <td style={styles.cell}>
                    <p>CVM</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Taran et al. 2016</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Ghodaghodi wetland, Nepal</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2563 ha</p>
                  </td>
                  <td style={styles.cell}>
                    <p>674,000 US$/yr</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      Market price method, net revenue method, value transfer
                      method, and CVM
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Aryal et al. 2021</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Koshi Tappu wildlife</p>
                    <p>reserve, Nepal</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      175 km<sup>2</sup>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>USD 16 million/yr</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Market-based and value transfer method</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Sharma et al. 2015</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              The total ecosystem supply value (TESV) is the sum of
              provisioning, regulating, and cultural services, illustrated in
              figure 3 (SEEA 2021). The value of an asset is determined by
              estimating the net present value (NPV) based on the stream of
              income expected to be earned in the future and then discounting
              the future income back to the present accounting period (SEEA
              2021).
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/esk3.jpg" alt="" />
            </p>
            <p style={{textAlign:"center"}}>
              <strong>Figure 3: </strong>TESV framework for valuation of
              ecosystem services
            </p>
            <p>
              Valuation of wetland ecosystem services would aid in formulating
              strategies for wetland conservation to protect biodiversity, and
              sustainable use of wetland resources. The main objectives of this
              study were to assess total ecosystem supply value (TESV) and
              assess the net present value (NPV) of wetlands in Karnataka,
              India. This entails accounting provisioning services, regulating
              services, and cultural services, considering services provided by
              algae, fish, and macrophytes.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
